// Gói AI học tập của học sinh (100k/30 ngày, khoá hệ thống) + quét phiếu đáp án viết tay.
// Backend: backend/routers/student_ai.py
import { API_CONFIG } from '../config/api.config'

const BASE = `${API_CONFIG.python.apiUrl}/student-ai`

export interface StudentAIStatus {
  active: boolean
  until: string | null
  days_left: number
  price_vnd: number
  plan_days: number
  limits: { review: number; ask: number; scan: number }
  usage: { review: number; ask: number; scan: number }
  memo: string
  bank: { bank_id: string; account: string; account_name: string } | null
  zalo: string
}

export interface SheetItem {
  question_id: string
  group: 'TN' | 'DS' | 'TL'
  index: number
  number?: number      // số câu IN trên phiếu
  raw: string
  value: string
  ok: boolean
}

/** code: STUDENT_AI_PLAN (402 — chưa có gói) | STUDENT_AI_QUOTA (429 — hết lượt tháng). */
export class StudentAIError extends Error {
  constructor(message: string, public status: number, public code?: string) {
    super(message)
  }
}

export function token(): string {
  return localStorage.getItem('jwt_token') || localStorage.getItem('auth_token') || localStorage.getItem('token') || ''
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { Authorization: `Bearer ${token()}`, ...(init?.headers || {}) },
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({} as any))
    const d = body?.detail
    const message = typeof d === 'object' && d ? d.message : (d || `Lỗi ${res.status}`)
    throw new StudentAIError(String(message), res.status, typeof d === 'object' && d ? d.code : undefined)
  }
  return res.json()
}

export const studentAi = {
  status: () => call<StudentAIStatus>('/status'),
  review: (attemptId: string) =>
    call<{ content: string; cached: boolean }>(`/review/${attemptId}`, { method: 'POST' }),
  // k = mã ký trong QR phiếu GV phát (cho HS chưa vào danh sách lớp vẫn được AI kiểm tra)
  scanSheet: (examId: string, file: File, ma?: string | null, k?: string | null) => {
    const fd = new FormData()
    fd.append('file', file)
    if (ma) fd.append('ma', ma)   // mã đề → server đọc theo đúng bố cục bản in của mã đó
    if (k) fd.append('k', k)
    return call<{ code?: string | null; read: number; items: SheetItem[]; unsure: number; counts: Record<string, number>; usage: StudentAIStatus['usage']; limits: StudentAIStatus['limits'] }>(
      `/scan-sheet/${examId}`, { method: 'POST', body: fd })
  },
  // Tầng 2: các ô có chữ, ghép thành ảnh 512×512 có nhãn → AI đọc (chế độ rẻ, rẻ hơn gửi cả phiếu).
  scanCells: (examId: string, mosaics: Blob[], cells: { label: string; group: string }[], ma?: string | null, k?: string | null) => {
    const fd = new FormData()
    mosaics.forEach((m, i) => fd.append('files', new File([m], `cells-${i + 1}.jpg`, { type: 'image/jpeg' })))
    fd.append('cells', JSON.stringify(cells))
    if (ma) fd.append('ma', ma)
    if (k) fd.append('k', k)
    return call<{ values: Record<string, string>; usage: StudentAIStatus['usage']; limits: StudentAIStatus['limits'] }>(
      `/scan-cells/${examId}`, { method: 'POST', body: fd })
  },
}

/** Ảnh QR VietQR chuyển khoản đúng số tiền + nội dung để webhook tự kích hoạt gói. */
export function planQrUrl(s: StudentAIStatus): string | null {
  if (!s.bank) return null
  return `https://img.vietqr.io/image/${s.bank.bank_id}-${s.bank.account}-compact2.png?amount=${s.price_vnd}`
    + `&addInfo=${encodeURIComponent(s.memo)}&accountName=${encodeURIComponent(s.bank.account_name)}`
}
